import template from "./pCasemanTeamClientErp.html";

export function pCasemanTeamClientErpDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanTeamClientErpController,
    controllerAs: 'pCasemanTeamClientErp',
    bindToController: true
  };

  return directive;
}

class pCasemanTeamClientErpController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, Utils, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.showOnlyActive = true;
    this.activeClients = [];

    this.headers = [
      {name: "CASEMAN.CLIENT_KLIX", class: "table-info"},
      {name: "CASEMAN.CLIENT_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        //Notes...
        const timeout = this.$interval(() => {this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getTeamClients(),
          this.Caseman.getTeamCasemanClients()
        ];

        this.$q.all(promises).then(
          (success) => {
            this.clientsKlix = success[0].data && success[0].data.sort(this.Sort.abcBy("name")) || [];

            const clientsCASEMAN = success[1].data;

            if (clientsCASEMAN && clientsCASEMAN.length > 0) {
              this.clientsCASEMAN = clientsCASEMAN.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                .sort(this.Sort.abcBy("name"));
              this.activeClients = clientsCASEMAN.filter(client => client.isActive);
            } else {
              this.clientsCASEMAN = [];
            }

            this.toggleActive();

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  getMapperToDisplay(klixClients) {
    const mapperToDisplay = klixClients && klixClients.map(clientKlix => {

      let client = {
        clientId: clientKlix.id,
        clientName: clientKlix.name,
        isActive: clientKlix.isActive,
        casemanClientName: clientKlix.casemanClientName,
        unmatched: true
      };
      if (clientKlix.casemanClientName !== undefined) {
        client = {
          ...client,
          unmatched: false
        };
      }
      return client;
    });
    return mapperToDisplay;
  }

  back() {
    window.history.back();
  }

  toggleActive() {
    if (this.showOnlyActive) {
      this.mapperToDisplay = this.getMapperToDisplay(this.activeClients);
    } else {
      this.mapperToDisplay = this.getMapperToDisplay(this.clientsCASEMAN);
    }
  }

}